import { stocks } from 'redevConfig'

const list = (stocks && stocks.list) || ''
const declareStockView = list ? require(`redevelopment/outputManage/stocks/${list.templateName}`) : require('./views/declareStock.html')
export default {
    base: {
        state: 'outputManage.stock.declareStock',
        config: {
            url: '/declareStock',
            abstract: true,
            template: '<div ui-view></div>',
            // controller: 'declareStockRootCtrl',
        },
    },
    list: {
        state: 'outputManage.stock.declareStock.list',
        config: {
            url: '/list',
            template: declareStockView,
            controller: 'declareStockCtrl',
            title: '发票库存',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/stocks/routers.js